import React from "react";
import { Row, Col, Tag, Skeleton, Button } from "antd";
import { WidgetData } from "@ts/common-types";
import { StarFilled } from "@ant-design/icons";
import WidgetCard from "./WidgetCard";
import { REVSTACK_THEME_COLORS } from "@/ts/constants";
import { useDispatch } from "react-redux";
import { updateChangeSkuState } from "@/features/modalSlice";
import { BsBoxArrowUpRight } from "react-icons/bs";

interface IRevstackProductAnalysisBanner {
    widgetData: WidgetData;
        config: {
            isChangeSkuBtnRequired: boolean;
        };
}

const RevstackProductAnalysisBanner: React.FC<
    IRevstackProductAnalysisBanner
> = ({ widgetData, config }) =>
{
    const dispatch = useDispatch();

  return widgetData?.isLoading ? (
        <Skeleton.Node className="w-100" active style={{ height: "150px" }} />
    ) : (
        <WidgetCard
            className="rounded-0"
            overwriteDefaultClass={true}
            bodyPaddingClass="px-3 py-0"
            style={{
                height: "150px",
            }}
        >
            <Row
                gutter={[20, 20]}
                className="mx-2"
                align="middle"
                justify="space-around"
            >
                {/* Product Image Section */}
                <Col span={3}>
                    <div
                        className="text-center"
                        style={{
                            width: "114px",
                            height: "101px",
                        }}
                    >
                        <img
                            className="w-100 d-block object-fit-contain"
                            src={widgetData?.data?.image}
                            alt="Product"
                            style={{
                                height: widgetData?.data?.quantity ? 72 : 110,
                                borderRadius: "6px 6px 0 0",
                            }}
                        />
                        {widgetData?.data?.quantity && (
                            <div
                                style={{
                                    background: `${REVSTACK_THEME_COLORS.coral[50]}`,
                                    color: `${REVSTACK_THEME_COLORS.coral[500]}`,
                                    padding: "4px 12px",
                                    fontSize: "12px",
                                    fontWeight: "500",
                                    display: "inline-block",
                                    width: "100%",
                                    height: "28px",
                                    borderRadius: "0 0 6px 6px",
                                }}
                            >
                                {widgetData?.data?.quantity}
                            </div>
                        )}
                    </div>
                </Col>

                {/* Product Details Section */}
                <Col span={17}>
                    <div className="py-3">
                        <div className="d-flex align-items-center">
                            <h6 className="text-muted">
                                SKU:{" "}
                                <span className="text-primary">
                                    {widgetData?.data?.sku}
                                </span>
                            </h6>
                            <div className="d-flex align-items-center gap-1 ms-3 pb-2">
                                <span
                                    className="px-2"
                                    style={{
                                        backgroundColor: `${REVSTACK_THEME_COLORS.warning[100]}`,
                                        borderRadius: "5px",
                                    }}
                                >
                                    <StarFilled
                                        className="star-icon"
                                        style={{
                                            color: `${REVSTACK_THEME_COLORS.warning[500]}`,
                                        }}
                                    />
                                    <span className="fw-600">
                                        {widgetData?.data?.rating}
                                    </span>
                                </span>
                                <span className="fw-600">
                                    {widgetData?.data?.reviewCount
                                        ? widgetData?.data?.reviewCount
                                        : "-"}
                                </span>
                            </div>
                        </div>

                        <h5>{widgetData?.data?.title}</h5>

                      <div className="d-flex gap-2 align-items-center">
                          <Tag
                              className="border"
                              color={`${REVSTACK_THEME_COLORS.lightGrayBlue[100]}`}
                              style={{
                                  color: "#2D2D2D",
                                  borderColor: `${REVSTACK_THEME_COLORS.lightGrayBlue[100]}`,
                              }}
                          >
                              {widgetData?.data?.tags[0]}
                          </Tag>
                          <h6 className="text-primary mb-0 fw-600">
                              {widgetData?.data?.tags[1]}
                          </h6>
                          <BsBoxArrowUpRight
                              role="button"
                              style={{ color: "#919191", marginLeft: "4px" }}
                              size={14}
                              onClick={() => {
                                  const urlToOpen =
                                      widgetData?.data?.product_url || "";
                                  window.open(urlToOpen, "_blank");
                              }}
                          />
                      </div>
                  </div>
              </Col>

                {/* Pricing and change SKU Section */}
                <Col span={4}>
                    <div className="text-end">
                        <h5>{widgetData?.data?.currentPrice}</h5>
                        <h6 className="text-decoration-line-through text-danger">
                            {widgetData?.data?.originalPrice}
                        </h6>
                          {config?.isChangeSkuBtnRequired && (
                              <Button type="primary" color="primary"
                                  style={{ backgroundColor: `${REVSTACK_THEME_COLORS.primary[700]}`, borderColor: `${REVSTACK_THEME_COLORS.primary[700]}` }}
                                  onClick={() => {
                                      dispatch(updateChangeSkuState({
                                          show: true
                                      }));
                                  }}>
                                  Change SKU
                              </Button>
                          )}
                    </div>
                </Col>
            </Row>
        </WidgetCard>
    );
};
export default RevstackProductAnalysisBanner;